import type { ContextFileSelection } from 'types/contextDocuments';

/**
 * Нормализует значение из localStorage / внешнего источника в ContextFileSelection[].
 * Поддерживает миграцию старого формата string[] (до обновления бэка).
 */
export function normalizeContextFileSelections(raw: unknown): ContextFileSelection[] {
  if (!Array.isArray(raw)) return [];
  const result: ContextFileSelection[] = [];
  for (const item of raw) {
    if (typeof item === 'string') {
      result.push({ id: item });
      continue;
    }
    if (item && typeof item === 'object' && typeof (item as { id?: unknown }).id === 'string') {
      const id = (item as { id: string }).id;
      const rawHeaders = (item as { headers?: unknown }).headers;
      const headers = Array.isArray(rawHeaders)
        ? rawHeaders.filter((h): h is string => typeof h === 'string')
        : [];
      result.push(headers.length > 0 ? { id, headers } : { id });
    }
  }
  return result;
}
